<template>
    <form ref="form" v-on="formEvents">
        <h5 v-if="currency === 'ZWG'" class="mb-3 text-black font-weight-bold text-uppercase">
            Econet Smart Bundles
        </h5>
        <div v-if="loading"
             class="text-center text-primary text-20 line-height-07 mb-5 mt-5 d-flex justify-content-center align-items-center">
            <div class="loader"></div>
        </div>
        <div class="form-group">
            <label>Beneficiary Phone Number</label>
            <phone-input v-model="form.receiver" :countries="['ZW']" @keyup="showForm"></phone-input>
            <div v-text="form.errors.get('receiver')" class=" bg-danger rounded-bottom text-white text-center text-1 mt-0"/>
            <div class="alert alert-info mt-2 text-center"  v-if="form.errors.get('receiver')">
                <small>
                    Enter SmartBiz Number & try again <b>OR</b> Buy
                    <router-link to="/airtime/netone"  class="ml-1 btn btn-sm bg-white shadow-none">
                        <img  class="bill-img" :src="logos.NetOne" height="10" alt="">
                    </router-link>
                </small>
            </div>
        </div>
        <transition name="slide-in-top">
            <div >
                <div v-if="!loading" class="form-group">
                    <label>Bundle</label>
                    <select v-model="form.bundle" required
                            :class="[ 'custom-select' , form.errors.get('bundle') ? 'is-invalid' : '' ]">
                        <option value="">Choose Bundle</option>
                        <option v-for="b in filteredBundles" :value="b.id">{{ methods[form.payment] }} ${{ b.price }} -
                            {{ b.description }}
                        </option>
                    </select>
                    <div v-text="form.errors.get('bundle')" class="invalid-feedback"/>
                </div>

                <div class="form-group">
                    <label>Pay with</label>
                    <select v-model="form.payment"
                            :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                        <option value="ecocash-usd">EcoCash USD</option>
                        <option value="stripe">International Card</option>
                    </select>
                    <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                </div>

                <div v-if="form.payment === 'ecocash' || form.payment === 'ecocash-usd'" class="form-group">
                    <label>EcoCash Phone Number</label>
                    <phone-input key="1" v-model="form.phone" :countries="['ZW']"></phone-input>
                    <div v-text="form.errors.get('phone')" class="text-danger"/>
                    <small class="text-black-50">* Also used for notifications</small>
                </div>

                <div class="form-group">
                    <label>Email</label>
                    <input type="email" v-model="form.email" value="email"
                           required
                           :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                           placeholder="Email">
                    <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                </div>

                <div class="form-group">
                    <label>Amount <br></label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        {{ methods[form.payment] }}
                    </span>
                        </div>
                        <input type="number" disabled :value="discounted"
                               :class="[ 'form-control' , form.errors.get('amount') ? 'is-invalid' : '' ]"
                               placeholder="Amount">
                        <div v-text="form.errors.get('amount')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="form-group d-flex align-items-center">
                    <input type="checkbox" class="mr-2" id="checkterms" v-model="termsAccepted">
                    <label class="mb-0" for="checkterms">I accept the <a target="_blank" href="/terms">Terms & Conditions</a></label>
                </div>
            </div>
        </transition>
        <div class="form-group">
            <button @click="formVisibility ? submit($event) : (formVisibility = true)"
                    type="button"
                    v-on="buttonValidity"
                    :class="{'btn-loading': form.loading || loading, ...buttonValidity.class}">
                Buy Bundle
            </button>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import {validity} from "../../../core/forms/validity";
import {storage} from "../../../core/utils/storage";
import {appDataMixin} from "../../../core/data/global";

export default {
    name: "econet-smart-usd-bundles",
    components: {PhoneInput: () => import("../../custom/phone-input.vue")},
    mixins: [validity, storage, appDataMixin],
    data: function () {
        return {
            loading: true,
            methods: {
                'ecocash': 'ZWG',
                'ecocash-usd': 'USD',
                'stripe': 'USD',
            },
            bundles: [],
            categories: [],
            rate: 1,
            discount: 1,
            form: new Form({
                'receiver': '',
                'payment': 'stripe',
                'category': '',
                'bundle': '',
                'phone': '',
                'amount': '',
                'email': '',
                'currency': 'USD',
                'network': 'econet',
            })
        };
    },
    computed: {
        actual_discount() {
            return Math.floor((((this.discount) / (1 + this.discount)) * 100));
        },
        price: function () {
            return this.calculateUsdPrice(this.selected_bundle_price);
        },
        discounted: function () {
            return this.calculateDiscountedUsdPrice(this.selected_bundle_price);
        },
        selected_bundle_price() {
            return this.form.bundle !== '' && !this.loading ? this.bundles.find(e => e.id === this.form.bundle).price : 0
        },
        filteredBundles() {
            return this.bundles.filter(bundle => bundle.category === 'SMARTBiZ');
        }
    },
    methods: {
        calculateUsdPrice(price) {
            return price;
        },

        calculateDiscountedUsdPrice(price) {
            return price;
        },

        fetchBundles() {
            this.loading = true;
            window.axios.get(`${window.location.origin}/bundles/prepare/smart`).then((response) => {
                this.bundles = response.data.body.bundles;
                this.categories = response.data.body.categories;
                this.rate = response.data.body.rate;
                this.discount = response.data.body.discount / 100;
                this.getFromLocalStorage();
            }).finally(() => {
                this.loading = false;
            });
        },

        submit(event){
            // Save to Local Storage
            if (this.valid) {
                event.preventDefault()

                this.saveToLocalStorage();
                this.form.submit('/bills/bundles/init').then((response) => {

                    // Redirect based on payment type
                    if (response.data.success) {
                        if (response.data.body.payment.payment === "ecocash-usd") {
                            this.$router.push(`/bundles/ecocash?id=${response.data.body.payment.ref}`);
                        }

                        if (response.data.body.payment.payment === "ecocash") {
                            this.$router.push(`/bundles/ecocash?id=${response.data.body.payment.ref}`);
                        }

                        if (response.data.body.payment.payment === "stripe") {
                            window.location.href = response.data.body.payment.url;
                        }

                    } else {

                    }
                });
            }
        }
    },
    mounted() {
        this.fetchBundles();
        this.initStorage([
            'receiver',
            'email',
        ], 'usd-bundles');
        this.scrollToTop();
    }
}
</script>
